import { Box } from '@mui/material';
import SimpleRow from 'components/SimpleRow';

interface ActionsProps {
  left?: [string, JSX.Element][];
  center?: [string, JSX.Element][];
  right?: [string, JSX.Element][];
}

const Actions = ({ left, center, right }: ActionsProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    {left ? <SimpleRow>{left}</SimpleRow> : <div />}
    {center ? <SimpleRow>{center}</SimpleRow> : <div />}
    {right ? <SimpleRow>{right}</SimpleRow> : <div />}
  </Box>
);

export default Actions;
